<template>
  <div class="modal fade" id="status-info-modal" tabindex="-1" role="dialog" aria-labelledby="status-info-modal-title"
       aria-hidden="true">
    <div class="modal-dialog modal-lg" role="dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="status-info-modal-title">Status info</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="status-info-text"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'help-modal'
  };
</script>
